<div
  class="ant-select ant-select-single ant-select-show-arrow w-full"
  [class.ant-select-active]="showTextItem"
  [class.ant-select-lg]="size === 'large'"
  [class.ant-select-sm]="size === 'small'"
  nz-dropdown
  nzTrigger="click"
  [nzDropdownMenu]="menu"
  [(nzVisible)]="visible"
  (nzVisibleChange)="visibleChange.emit($event)">
  <div class="ant-select-selector">
    <div *ngIf="showTextItem; else placeholderTpl" class="ant-select-selection-item">
      {{ textItem }}
    </div>
    <ng-template #placeholderTpl>
      <div class="ant-select-selection-placeholder">{{ placeholder }}</div>
    </ng-template>
  </div>
  <div class="ant-select-arrow">
    <i nz-icon nzType="down" nzTheme="outline"></i>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ng-content></ng-content>
</nz-dropdown-menu>
